<div class="school-class-compare-block-legend" *ngIf="data">
  <div class="school-class-compare-block-legend__legend-item" *ngFor="let legendItem of data">
    <div class="school-class-compare-block-legend__legend-item-circle" [ngStyle]="{'background-color': legendItem.color}"></div>
    <div class="school-class-compare-block-legend__legend-item-label">{{legendItem.label}}</div>
  </div>
</div>
